module.exports = __webpack_public_path__ + "static/people-slider-image-442e5dd1e8a75eaac09ddd4c795fb62f.jpg";